import React from 'react';
import PropTypes from 'prop-types';

const ChevronIcon = ({ style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style={style}>
    <path d="M17.5,7.08A1.62,1.62,0,0,0,17,6,1.6,1.6,0,0,0,14.8,6L10,10.71,5.2,6A1.6,1.6,0,0,0,3,6,1.58,1.58,0,0,0,3,8.18l5.92,5.87A1.61,1.61,0,0,0,10,14.5a1.63,1.63,0,0,0,1.12-.45L17,8.19A1.6,1.6,0,0,0,17.5,7.08Z" />
  </svg>
);

ChevronIcon.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.objectOf(PropTypes.string),
  ]),
};

ChevronIcon.defaultProps = {
  style: null,
};

export default ChevronIcon;
